import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Header.css';

const Header = ({ activePage = '' }) => {
  const navigate = useNavigate();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleLogoClick = () => {
    navigate('/');
  };

  const handleResumeDownload = () => {
    // Import and use the resume download function
    import('../utils/resumeDownload').then(module => {
      module.downloadResume();
    });
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <header className="header">
      <div className="header-content">
        <div className="logo" onClick={handleLogoClick} style={{ cursor: 'pointer' }}>Subs.</div>
        
        {/* Desktop Navigation - Hidden on mobile */}
        <nav className="navigation desktop-nav">
          <a href="/about" className={activePage === 'about' ? 'active' : ''}>About</a>
          <a href="/#works" className={activePage === 'works' ? 'active' : ''}>Works</a>
          <a href="/#resume" onClick={handleResumeDownload} className={activePage === 'resume' ? 'active' : ''}>Resume</a>
          <a href="/contact" className={activePage === 'contact' ? 'active' : ''}>Contact</a>
        </nav>
        
        {/* Mobile menu button - Only visible on mobile */}
        <button className="mobile-menu-btn" onClick={toggleMobileMenu}>
          <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>
      </div>

      {/* Mobile Navigation - Offset Canvas */}
      <div className={`mobile-nav-overlay ${isMobileMenuOpen ? 'active' : ''}`} onClick={closeMobileMenu}></div>
      <div className={`mobile-nav-canvas ${isMobileMenuOpen ? 'active' : ''}`}>
        <div className="mobile-nav-header">
          <div className="logo mobile-logo" onClick={handleLogoClick} style={{ cursor: 'pointer' }}>Subs.</div>
          <button className="close-menu-btn" onClick={closeMobileMenu} aria-label="Close menu">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M18 6L6 18M6 6l12 12"/>
            </svg>
          </button>
        </div>
        <nav className="mobile-nav">
          <a href="/about" className={activePage === 'about' ? 'active' : ''} onClick={closeMobileMenu}>Abouts</a>
          <a href="/#works" className={activePage === 'works' ? 'active' : ''} onClick={closeMobileMenu}>Works</a>
          <a href="/#resume" onClick={(e) => { handleResumeDownload(); closeMobileMenu(); }} className={activePage === 'resume' ? 'active' : ''}>Resume</a>
          <a href="/contact" className={activePage === 'contact' ? 'active' : ''} onClick={closeMobileMenu}>Contact</a>
        </nav>
      </div>
    </header>
  );
};

export default Header;
